import { activateI18n } from '../i18n';
import { messages as enMessages } from '../locales/en/messages';
import { messages as fiMessages } from '../locales/fi/messages';
import { messages as nbMessages } from '../locales/nb/messages';

activateI18n(enMessages, nbMessages, fiMessages);

export { LegendaryAdOfTheWeekSearchAd } from './legendary/LegendaryAdOfTheWeekSearchAd';
export { LegendaryBapSearchAd } from './legendary/LegendaryBapSearchAd';
export { LegendaryBoatSearchAd } from './legendary/LegendaryBoatSearchAd';
export { LegendaryJobSearchAd } from './legendary/LegendaryJobSearchAd';
export { LegendaryMotorSearchAd } from './legendary/LegendaryMotorSearchAd';
export { LegendaryRealestateSearchAd } from './legendary/LegendaryRealestateSearchAd';
